<template>
  <div :class="[$style.anchor_link, { [$style.fixed_bottom]: isFixedBottom }]">
    <div :class="[$style.images, { [$style.lpnh]: pageType === 'lpnh' }]">
      <!-- parts にユニークな ID が付与されていないため、index を使用 -->
      <template v-for="(parts, index) in partsList" :key="index">
        <div
          v-if="parts.pc_img_url"
          :class="[$style.image, { 'page-parts-pc': parts.sp_img_url || displayType === 'pc' }]"
        >
          <div :class="$style.image_button" @click="scrollToId(parts.description ?? undefined)">
            <AtomsConsumerImage :src="parts.pc_img_url" :width="1440" alt="" />
          </div>
        </div>
        <div v-if="parts.sp_img_url" :class="$style.image" class="page-parts-sp">
          <div :class="$style.image_button" @click="scrollToId(parts.description ?? undefined)">
            <AtomsConsumerImage :src="parts.sp_img_url" :width="1024" alt="" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DisplayType } from "@tential/ec-gql-schema/master/pageParts"
import { PagePartsFragmentFragment } from "~/types/pageParts"

type Props = {
  partsList: PagePartsFragmentFragment["list"]
  isFixedBottom?: boolean
  displayType?: DisplayType
  pageType?: string
}

withDefaults(defineProps<Props>(), {
  partsList: () => [],
  isFixedBottom: false,
  displayType: "all",
  pageType: "",
})

const scrollToId = (documentId: string | undefined): void => {
  if (!documentId) return
  const element = document.getElementById(`page_parts_${documentId}`)
  element?.scrollIntoView({
    behavior: "smooth",
  })
}
</script>

<style scoped module lang="scss">
.anchor_link {
  @include full-container-lg;
  &.fixed_bottom {
    position: fixed;
    max-width: none;
    width: 100%;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }
  .images {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    &.lpnh {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 720px;
      width: 100%;
      margin: 0 auto;
    }
    .image {
      width: 100%;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }

      &:hover {
        opacity: 0.7;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
    .image_button {
      cursor: pointer;
    }
  }
}
</style>
